// extracted by mini-css-extract-plugin
export var text = "_j-0";